import { documentQueryKeys } from "./queryKeys"
import { useDocumentQuery } from "./useDocumentQuery"

export function useDocumentTypes(params = {}) {
    const url = "document_types/"
    const queryKey = documentQueryKeys.types(params)

    return useDocumentQuery(
        url,
        queryKey,
        params,
        {
            autoRefetch: true,
        },
    )
}